[
  {
    "id": "logo",
    "x": 282,
    "y": 8,
    "w": 394,
    "h": 262
  },
  {
    "id": "sticker.upperleft",
    "x": 34,
    "y": 108,
    "w": 136,
    "h": 148
  },
  {
    "id": "sticker.upperright",
    "x": 728,
    "y": 104,
    "w": 194,
    "h": 146
  },
  {
    "id": "sticker.right",
    "x": 808,
    "y": 432,
    "w": 132,
    "h": 138
  },
  {
    "id": "card.friends",
    "x": 54,
    "y": 568,
    "w": 832,
    "h": 242
  },
  {
    "id": "card.meet",
    "x": 38,
    "y": 800,
    "w": 864,
    "h": 236
  },
  {
    "id": "card.flirt",
    "x": 20,
    "y": 1026,
    "w": 894,
    "h": 240
  },
  {
    "id": "playnow",
    "x": 26,
    "y": 1262,
    "w": 908,
    "h": 140
  },
  {
    "id": "tile.profile",
    "x": 52,
    "y": 1402,
    "w": 276,
    "h": 108
  },
  {
    "id": "tile.join",
    "x": 340,
    "y": 1402,
    "w": 265,
    "h": 108
  },
  {
    "id": "tile.howto",
    "x": 616,
    "y": 1402,
    "w": 273,
    "h": 108
  },
  {
    "id": "sticker.judgments",
    "x": 10,
    "y": 1496,
    "w": 180,
    "h": 168
  },
  {
    "id": "sticker.together",
    "x": 712,
    "y": 1534,
    "w": 224,
    "h": 134
  },
  {
    "id": "hud.credits",
    "x": 656,
    "y": 8,
    "w": 190,
    "h": 72
  },
  {
    "id": "hud.bell",
    "x": 848,
    "y": 4,
    "w": 88,
    "h": 84
  }
]
